module.exports = __webpack_public_path__ + "static/img/301240322151743389.682157c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/301240322151743389.jpg
// module id = Zy0v
// module chunks = 1